<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">{{title}}</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="tables.customer_info.dialogAdd=true">新增</v-btn>
        </div>
        <div>
          <v-btn
            depressed 
            color="success" class="btn_fontSize ml-2"
            @click="exportFile(tables.customer_info)"
            :loading="tables.isExporting"
          >
            匯出
          </v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="tables.customer_info.page"
            :length="tables.customer_info.pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="mr-5 tableDivider"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{tables.customer_info.total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="tables.customer_info.rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="tables.customer_info.rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="tables.customer_info.data"
        :headers="tables.customer_info.headers"
        :sort-by="tables.customer_info.sortItem"
        hide-default-header
        :sort-desc="tables.customer_info.sortOrder"
        :items-per-page='tables.customer_info.rows'
        :loading="tables.isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in tables.customer_info.headers"
                :key="header.value"
              >
                <div
                  @click="changeSort(header, tables.customer_info)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&tables.customer_info.sortItem===header.value">
                    <v-icon v-if="tables.customer_info.sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="header in tables.customer_info.headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value==='actions'">
                <v-icon
                  size = "35"
                  color="primary"
                  style="cursor: pointer;"
                  @click="openDialog('edit', item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  size = "35"
                  class="ml-2"
                  color="red"
                  style="cursor: pointer;"
                  @click="openDeleteDialog(tables.customer_info, item)"
                >
                  mdi-delete
                </v-icon>
              </div>
              <div v-else-if="header.value==='cartype_category'">
                <span>{{item.category_name}}</span>
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
      <!-- 新增編輯dialog -->
      <v-dialog overlay-opacity="0.2" max-width="800px" v-model="tables.customer_info.dialogAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">{{dialogTitle}}</v-card-title>
          <v-card-text>
            <v-form :ref="tables.customer_info.formEditRef">
              <div class="rowDiv contentCenter">
                <div style="width:250px">
                  <v-text-field
                    label="主帳號"
                    v-model="tables.customer_info.selectedData.customer_id"
                    :rules="rules.content"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :disabled='tables.customer_info.isEdit'
                  ></v-text-field>
                </div>
                <div style="width:250px" class="ml-2">
                  <v-text-field
                    label="登入密碼"
                    v-model="tables.customer_info.selectedData.customer_pwd"
                    :rules="rules.content"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :type="tables.customer_info.showPW ? 'text':'password'"
                    :append-outer-icon="tables.customer_info.showPW ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append-outer="PWControl"
                    autocomplete="off"
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter">
                <div style="width:250px" class="ml-2">
                  <v-switch
                    class="ma-0 pa-0"
                    v-model="tables.customer_info.selectedData.customer_use"
                    hide-details
                    true-value="Y"
                    false-value="N"
                    label="使用中"
                  ></v-switch>
                </div>
                <div style="width:250px" class="ml-2"></div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:250px">
                  <v-text-field
                    label="建立時間"
                    v-model="tables.customer_info.selectedData.create_dt"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
                <div class="ml-2" style="width:250px">
                  <v-text-field
                    label="建立人員"
                    v-model="tables.customer_info.selectedData.create_user"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:250px">
                  <v-text-field
                    label="更新時間"
                    v-model="tables.customer_info.selectedData.update_dt"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
                <div class="ml-2" style="width:250px">
                  <v-text-field
                    label="更新人員"
                    v-model="tables.customer_info.selectedData.update_user"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDialog(tables.customer_info)">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveData(tables.customer_info)">儲存</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 確認刪除主帳號dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="tables.customer_info.dialogDelete" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除主帳號</v-card-title>
          <v-card-text>
            <v-form :ref="tables.customer_info.formDeleteRef">
              <div class="rowDiv contentCenter">
                <div style="width:180px">
                  <v-text-field
                    label="主帳號"
                    v-model="tables.customer_info.selectedData.customer_id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDeleteDialog(tables.customer_info)">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deleteCustomer(tables.customer_info)">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 搜尋 sidebar -->
      <v-navigation-drawer
        app
        clipped
        class="rounded-lg mt-3"
        :width="sidebar.width"
        height="850"
        permanent
      >
        <div class="rowDiv">
          <v-card-title v-if="sidebar.open" class="headline font-weight-bold">篩選條件</v-card-title>
          <v-spacer>
          </v-spacer>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            :class="sidebar.iconClass"
            @click="sidebar.open=!sidebar.open"
          >{{sidebar.icon}}</v-icon>
        </div>
        <v-divider></v-divider>
        <div v-if="sidebar.open">
          <v-card-title style="height:50px;" class="searchTitle">主帳號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="tables.customer_info.search.customer_id.value"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle" v-if="false">主帳號名稱</v-card-title>
          <div style="width:220px; height:30px" class="ml-4" v-if="false">
            <v-text-field
              v-model="tables.customer_info.search.customer_nm.value"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle" v-if="false">客戶聯絡人</v-card-title>
          <div style="width:220px; height:30px" class="ml-4" v-if="false">
            <v-text-field
              v-model="tables.customer_info.search.customer_person.value"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle" v-if="false">聯絡人電話</v-card-title>
          <div style="width:220px; height:30px" class="ml-4" v-if="false">
            <v-text-field
              v-model="tables.customer_info.search.customer_phone.value"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle" v-if="false">聯絡人電子郵件</v-card-title>
          <div style="width:220px; height:30px" class="ml-4" v-if="false">
            <v-text-field
              v-model="tables.customer_info.search.customer_email.value"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
        </div>
      </v-navigation-drawer>
    </v-card>
  </v-container>
</template>
<script>

import Service from '../service/service'
export default {
  name: 'Customer_Info',
  data: () => ({
    title: '主帳號管理',
    tables: {
      isLoading: false,
      isExporting: false,
      customer_info: {
        formEditRef: 'newCustomerForm',
        formDeleteRef: 'deleteForm',
        urlGet: 'customer_info/getPageData',
        urlAdd: 'customer_info/Add',
        urlUpdate: 'customer_info/update',
        urlDelete: 'customer_info/del',
        urlExport: 'customer_info/Export',
        headers: [
          { text: '主帳號', value: 'customer_id',  sortable: true },
          // { text: '登入密碼', value: 'customer_pwd',  sortable: true },
          { text: '使用中', value: 'customer_use',  sortable: true },
          { text: '', value: 'actions', sortable: false }
        ],
        rows: 10,
        sortItem: '',
        sortOrder: false,
        pageCount: 0,
        page: 1,
        total: 0,
        rowsList: [10, 20, 30, 40, 50],
        search: {
          customer_id: {
              name: 'customer_id',
              value: '',
              displayType: 'like'
          },
          customer_nm: {
              name: 'customer_nm',
              value: '',
              displayType: 'like'
          },
          customer_person: {
              name: 'customer_person',
              value: '',
              displayType: 'like'
          },
          customer_phone: {
              name: 'customer_phone',
              value: '',
              displayType: 'like'
          },
          customer_email: {
              name: 'customer_email',
              value: '',
              displayType: 'like'
          }
        },
        data: [],
        selectedData: { 
          customer_id: '',
          customer_pwd: '',
          customer_use: 'Y',
          create_dt: '',
          create_user: '',
          update_dt: '',
          update_user: '',
          // 以下為新增/編輯 API 須帶資料 (不在畫面)
          customer_notify_id: '',
          enable_notify: '1',
          lang: 'zh-tw',
          timezone: 8,
          AccountType: '0',
          customer_ForceMP: 'N'
        },
        defaultData: { 
          customer_id: '',
          customer_pwd: '',
          customer_use: 'Y',
          create_dt: '',
          create_user: '',
          update_dt: '',
          update_user: '',
          // 以下為新增/編輯 API 須帶資料 (不在畫面)
          customer_notify_id: '',
          enable_notify: '1',
          lang: 'zh-tw',
          timezone: 8,
          AccountType: '0',
          customer_ForceMP: 'N'
        },
        isEdit: false,
        dialogAdd: false,
        dialogDelete: false,
        showPW: false
      }
    },
    rules: {
      content: [v => !!v || 'Required']
    },
    sidebar: {
      open: true, 
      width: 260,
      icon: 'mdi-arrow-expand-left',
      iconClass: 'mr-5'
    }
  }),
  mounted: function () {
    this.getPageData(this.tables.customer_info)
  },
  watch: {
    'sidebar.open' () {
        this.sidebar.width = this.sidebar.open ? 260 : 70
        this.sidebar.icon = this.sidebar.open ? 'mdi-arrow-expand-left' : 'mdi-tune-variant'
        this.sidebar.iconClass = this.sidebar.open ? 'mr-5' : 'mr-5 my-5'
    },
    'tables.customer_info.page': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.getPageData(this.tables.customer_info) }
      }
    },
    'tables.customer_info.rows': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.customer_info.page === 1 ? this.getPageData(this.tables.customer_info) : this.tables.customer_info.page = 1 }
      }
    },
    'tables.customer_info.search.customer_id.value' : {
      immediate: true,
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.customer_info.page === 1 ? this.getPageData(this.tables.customer_info) : this.tables.customer_info.page = 1 }
      }
    },
    'tables.customer_info.search.customer_nm.value' : {
      immediate: true,
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.customer_info.page === 1 ? this.getPageData(this.tables.customer_info) : this.tables.customer_info.page = 1 }
      }
    },
    'tables.customer_info.search.customer_person.value' : {
      immediate: true,
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.customer_info.page === 1 ? this.getPageData(this.tables.customer_info) : this.tables.customer_info.page = 1 }
      }
    },
    'tables.customer_info.search.customer_phone.value' : {
      immediate: true,
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.customer_info.page === 1 ? this.getPageData(this.tables.customer_info) : this.tables.customer_info.page = 1 }
      }
    },
    'tables.customer_info.search.customer_email.value' : {
      immediate: true,
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.customer_info.page === 1 ? this.getPageData(this.tables.customer_info) : this.tables.customer_info.page = 1 }
      }
    },
    // Ian, 20241121, watch customer_id for customer_pwd
    'tables.customer_info.selectedData.customer_id' : {
      immediate: true,
      handler: function (nvalue, ovalue) {
        if (this.tables.customer_info.isEdit) return
        if (ovalue === undefined) return
        this.tables.customer_info.selectedData.customer_pwd = this.tables.customer_info.selectedData.customer_id + '88888'
      }
    },
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    dialogTitle () {
      if (this.tables.customer_info.isEdit) {
        return '編輯主帳號'
      } else {
        return '新增主帳號'
      }
    }
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header, table) {
      if (!header.sortable) return

      if (header.value === table.sortItem) {
        table.sortOrder = !table.sortOrder
      } else {
        table.sortOrder = true
        table.sortItem = header.value
      }
      this.getPageData(table)
    },
    openDialog (type, item) {
      var table = this.tables.customer_info
      if (type === 'edit') {
        table.isEdit = true
        table.selectedData = Object.assign({}, item)
      } else {
        table.isEdit = false
      }
      table.dialogAdd = true
    },
    closeDialog (table) {
      table.isEdit = false
      table.dialogAdd = false
      this.resetSelectedData()
      if (this.$refs[table.formEditRef]) {
        this.$refs[table.formEditRef].resetValidation()
      }
      // // 暫時特別重取頁面資料
      // this.getPageData(table)
    },
    getPageData (table) {
      this.tables.isLoading = true
      table.pageCount = 0
      table.data = []
      var wheres = []
      for (var variable in table.search) {
        wheres.push(table.search[variable])
      }
      var parm = {
        page: table.page,
        rows: table.rows,
        order: table.sortOrder ? 'desc' : 'asc',
        sort: table.sortItem,
        wheres: JSON.stringify(wheres),
        url: table.urlGet
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            table.total = response.data.total
            table.pageCount = Math.ceil(table.total / table.rows)
            table.data = response.data.rows
            // console.log(table.data)
          }
        })
      .finally(() => {
        this.tables.isLoading = false
      })
    },
    saveData (table) {
      if (this.$refs[table.formEditRef].validate()) {
        var url = table.isEdit ? table.urlUpdate : table.urlAdd
        Service.updateData(table.selectedData, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getPageData(table)
              this.closeDialog(table)
            }
          })
      }
    },
    openDeleteDialog (table, item) {
      table.dialogDelete = true
      table.selectedData.customer_id = item.customer_id
    },
    closeDeleteDialog (table) {
      table.dialogDelete = false
      this.resetSelectedData()
      if (this.$refs[table.formDeleteRef]) {
        this.$refs[table.formDeleteRef].resetValidation()
      }
    },
    deleteCustomer (table) {
      if (this.$refs[table.formDeleteRef].validate()) {
       
        var deleteList = []
        deleteList.push(table.selectedData.customer_id)
        const url = table.urlDelete
        Service.deleteData(deleteList, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getPageData(table)
              this.closeDeleteDialog(table)
            }
          })
      }
    },
    exportFile (table) {
      this.tables.isExporting = true
      var wheres = []
      for (var variable in table.search) {
        wheres.push(table.search[variable])
      }
      var parm = {
        wheres: JSON.stringify(wheres),
        url: table.urlExport
      }
      Service.exportFile(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var filename = this.title + '.xlsx'
            var downloadURL = ''
            var binaryData = []
            binaryData.push(response.data)
            downloadURL = URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }))
            var link = document.createElement('a')
            link.href = downloadURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link = null
          }
        })
      .finally(() => {
        this.tables.isExporting = false
      })
    },
    resetSelectedData () {
      this.tables.customer_info.selectedData = Object.assign({}, this.tables.customer_info.defaultData)
    },

    PWControl () {
      this.tables.customer_info.showPW = !this.tables.customer_info.showPW
    }
  }
}
</script>
